'use strict';

export {
	default as FileListEndpointDataProvider
} from './fileList.endpoint.dataProvider';
